var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field-main", on: { mousedown: _vm.fieldsAreaDown } },
    _vm._l(_vm.fields, function (field) {
      return _c(
        "el-button",
        {
          key: field.id,
          staticClass: "field-area",
          attrs: { title: field.name, size: "mini" },
          on: {
            click: function ($event) {
              return _vm.fieldSelect(field)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(field.name) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }